// extracted by mini-css-extract-plugin
export default {"main":"button_main__-OVWZ","inverted":"button_inverted__ZU5dK","sm":"button_sm__aeiHj"};